module.exports = __webpack_public_path__ + "img/pr-7.63d258eb.png";